import React, { useEffect, useState } from "react";
import { Card, Empty } from "./TvBits";

const SECTIONS = [["world", "WORLD", "#F59E0B"], ["us", "US", "#38BDF8"], ["markets", "MARKETS", "#10B981"], ["industry", "FREIGHT · HALAL", "#F43F5E"], ["local", "LOCAL", "#A78BFA"]];

export const TvNews = ({ d }) => {
  const news = d.news || {};
  const live = SECTIONS.filter(([k]) => (news[k] || []).length);
  const [i, setI] = useState(0);
  useEffect(() => { const t = setInterval(() => setI((x) => x + 1), 12000); return () => clearInterval(t); }, []);
  if (!live.length) return <Card title="NEWS" className="h-full"><Empty>Loading news…</Empty></Card>;
  const [key, label, col] = live[i % live.length];
  const items = news[key];
  const hero = items.find((x) => x.image);
  return (
    <div className="h-full flex flex-col gap-4" data-testid="tv-scene-news">
      <div className="flex gap-3 shrink-0 flex-nowrap overflow-hidden">
        {SECTIONS.map(([k, l, c]) => (
          <span key={k} data-testid={`tv-news-tab-${k}`} className="nx-orbitron text-[clamp(0.75rem,0.95vw,1.125rem)] whitespace-nowrap shrink-0 font-bold tracking-widest px-4 py-1.5 rounded-lg transition-colors"
            style={k === key ? { background: c, color: "#030712" } : { color: `${c}99`, border: `1px solid ${c}33` }}>{l}{k === "local" && d.city ? ` · ${d.city.toUpperCase()}` : ""}</span>
        ))}
      </div>
      <div key={key} className="flex-1 min-h-0 grid grid-cols-5 gap-5 nx-fade-up">
        {hero && (
          <div className="col-span-2 relative rounded-3xl overflow-hidden">
            <img src={hero.image} alt="" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#030712] to-transparent" />
            <p className="absolute bottom-0 p-6 text-[clamp(1.25rem,2.2vw,2.5rem)] font-black leading-tight text-white line-clamp-3">{hero.title}</p>
          </div>
        )}
        <div className={`${hero ? "col-span-3" : "col-span-5"} nx-hud rounded-3xl p-6 space-y-5 overflow-hidden`} data-testid={`tv-news-list-${key}`}>
          {items.filter((x) => x !== hero).slice(0, 5).map((x, k) => (
            <div key={k} className="border-l-4 pl-4" style={{ borderColor: col }}>
              <p className="text-[clamp(1rem,1.5vw,1.75rem)] font-semibold leading-snug text-cyan-50 line-clamp-3">{x.title}</p>
              {x.source && <p className="text-lg mt-1" style={{ color: `${col}cc` }}>{x.source}</p>}
            </div>
          ))}
        </div>
      </div>
      <p className="sr-only">{label}</p>
    </div>
  );
};
